// @ts-check
import { store } from '@/store'

import {
  AUTHENTICATION_REQUIRED,
  HIDE_TITLE_ON_MOBILE,
  IS_IN_MAIN_NAV,
  ROUTE_NAME
} from '@/router/meta'

/** @type {import('vue-router').RouteRecordRaw} */
export const listExpensesRoute = {
  path: '/expenses',
  name: 'expenses',
  component: () => import('@/views/expense/ExpenseIndex.vue'),
  meta: {
    [AUTHENTICATION_REQUIRED]: true,
    [IS_IN_MAIN_NAV]: true,
    icon: '$cash-minus',
    [ROUTE_NAME]: 'expenses'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const createExpenseRoute = {
  path: '/expenses/new',
  name: 'new_expense',
  component: () => import('@/views/expense/ExpenseCreate.vue'),
  beforeEnter: (to, from, next) => {
    // Clear assignment before entering
    store.commit('assignment/clearData')
    next()
  },
  meta: {
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'new_expense',
    [HIDE_TITLE_ON_MOBILE]: true
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const editExpenseRoute = {
  path: '/expenses/:id',
  name: 'edit_expense',
  component: () => import('@/views/expense/ExpenseEdit.vue'),
  beforeEnter: (to, from, next) => {
    // Clear assignment before entering
    store.commit('assignment/clearData')
    next()
  },
  meta: {
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'edit_expense',
    [HIDE_TITLE_ON_MOBILE]: true
  }
}

/** @type {import('vue-router').RouteRecordRaw[]} */
export const expenseRoutes = [
  listExpensesRoute,
  createExpenseRoute,
  editExpenseRoute
]

export default expenseRoutes
